module.exports = __webpack_public_path__ + "img/america-4.4500a4e3.png";